export default "<app-loader> </app-loader>\n\n<router-outlet></router-outlet>\n"